import { render, staticRenderFns } from "./BtnGroup.vue?vue&type=template&id=7c19a555"
import script from "./BtnGroup.vue?vue&type=script&lang=js"
export * from "./BtnGroup.vue?vue&type=script&lang=js"
import style0 from "./BtnGroup.vue?vue&type=style&index=0&id=7c19a555&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports